var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "auth-main auth-main__prp" }, [
    _c(
      "main",
      {
        staticClass: "main--login",
        attrs: { id: "main", "data-page-id": "login" }
      },
      [
        _c("section", { staticClass: "section-login" }, [
          _c("div", { staticClass: "login-form-wrapper" }, [
            _c(
              "div",
              { staticClass: "loginv2-container p-b-20" },
              [
                _c("div", { staticClass: "row p-10" }, [
                  _c("div", {
                    staticClass: "login_logo login_logo__prp",
                    class: { "login_logo--ringba": !_vm.isWhitelabel }
                  }),
                  _vm._v(" "),
                  _c("br")
                ]),
                _vm._v(" "),
                _vm._t("default")
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        !_vm.isWhitelabel ? _c("Footer") : _vm._e(),
        _vm._v(" "),
        _vm.isWhitelabel ? _c("WhitelabelFooter") : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }